<template>
  <div class="course-price">
    <UiPriceInfo
      :price="price"
      :program="program"
      size="big"
      :tag-size="tagSize"
      in-row
      class="course-price__price"
    />

    <UiButton
      theme="quinary"
      :size="buttonSize"
      stretch
      class="course-price__button"
      @click="$emit('click:pay', accessType === AccessTypeEnum.Free ? AccessTypeEnum.Free : AccessTypeEnum.Paid)"
    >
      {{ computedButtonText }}
    </UiButton>

    <Timer
      v-if="computedTimer"
      :timer="computedTimer"
      format="dd:hh:mm:ss"
      class="course-price__timer f f--2 f--m"
    />
  </div>
</template>

<script setup lang="ts">
  import UiPriceInfo from '@academica-box/components/Price/UiPriceInfo/UiPriceInfo.vue'
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import type { Price } from '@academica-box/components/Cards/UiProductCard/types'
  import type { Tag } from '@academica-box/components/Plaques/UiTag/types'
  import Timer from '@/components/Timer/Timer.vue'
  import { AccessTypeEnum } from '@/helpers/mappingCourseData'

  const props = withDefaults(defineProps<{
    price: Price;
    program?: Tag;
    accessType: AccessTypeEnum;
    tagSize?: 'small' | 'medium' | 'big' | 'extra-small' | 'extra-big';
    buttonSize?: 'small' | 'extra-big' | 'medium' | 'big' | 'extra-small' | 'giant';
    isSubscriptionAvailable: boolean;
  }>(), {
    program: undefined,
    tagSize: 'small',
    buttonSize: 'extra-big',
  })

  defineEmits(['click:pay'])

  const computedTimer = computed(() => {
    if (props.price.discount?.end_date) {
      return Number(new Date(props.price.discount.end_date)) - Number(new Date())
    } else {
      return null
    }
  })

  const computedButtonText = computed(() => {
    if (props.accessType === AccessTypeEnum.Free) {
      return 'Учиться бесплатно'
    } else if (props.isSubscriptionAvailable) {
      return 'Купить навсегда'
    }

    return 'Купить'
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;

  .course-price__price {
    &:not(:last-child) {
      margin-bottom: 9px;
    }
  }

  .course-price__button {
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  .course-price__notice {
    margin: 0;
    color: var(--text-secondary-color);
    text-align: center;
  }

  .course-price__timer {
    display: block;
    margin-top: 12px;
    color: var(--text-secondary-color);
  }
</style>
